var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeopleGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 4C17.7225 4 16.5125 4.9613 15.77 6.41698C17.0075 7.90012 17.75 9.93258 17.75 12.2672C17.75 13.0637 17.6675 13.7778 17.5025 14.4919C18.025 14.794 18.5475 15.0137 19.125 15.0137C21.4075 15.0137 23.25 12.5418 23.25 9.5206C23.25 6.49938 21.4075 4.02747 19.125 4.02747V4ZM10.875 6.74657C8.5925 6.74657 6.75 9.21848 6.75 12.2397C6.75 15.2609 8.5925 17.7328 10.875 17.7328C13.1575 17.7328 15 15.2609 15 12.2397C15 9.21848 13.1575 6.74657 10.875 6.74657ZM23.9375 15.4257C22.755 16.8265 21.1325 17.6779 19.29 17.7328C20.0325 18.7765 20.5 20.0399 20.5 21.4132V23.226H26V18.6667C26 17.2385 25.1475 16.0025 23.9375 15.3983V15.4257ZM6.0625 18.1723C4.8525 18.7765 4 20.0125 4 21.4407V26H17.75V21.4407C17.75 20.0125 16.8975 18.7765 15.6875 18.1723C14.45 19.628 12.7725 20.4794 10.875 20.4794C8.9775 20.4794 7.3 19.6005 6.0625 18.1723Z",
    fill: "#7D94AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeopleGray);
export default __webpack_public_path__ + "static/media/icon-people-gray.18c8b249f4f8c4a56a6af7199e229334.svg";
export { ForwardRef as ReactComponent };